

<!-- The sidebar -->
<div class="sidebar border mobhide" *ngIf="router.url !='/dashboard/dashboard-mga' && !activeRoute?.includes('/mga-details') && router.url!='/dashboard/sales-home' && router.url!='/dashboard/policy-search' && router.url!='/dashboard/Save-Quotes' && router.url!='/dashboard/Quotes-Purchase' && router.url!='/dashboard/Groups' && router.url!='/dashboard/policy-details' && router.url!='/dashboard/policy-full-refund' && router.url!='/dashboard/change-policy' && router.url!='/dashboard/edit-billing-info' && router.url!='/dashboard/sales-report' && router.url!='/dashboard/report-details' && router.url!='/dashboard/agency-admin' && router.url!='/dashboard/forms' && router.url!='/dashboard/resources' && router.url!='/dashboard/OASale-report' && router.url!='/dashboard/OASale-report-details' &&  router.url!='/dashboard/vtc'">
    <div class="clear10"></div>
    <div class="menu outline-0 cp" (click)="onClickLogo()"><img class="tablogo" src="./assets/images/tl-215.png"  /></div>
    <!-- <div class="clear20"></div> -->
    <h6 class="semi-bold txt-black2 menu">STEPS</h6>
    <div class="clear10"></div>
    <a class="border-bottom" routerLink="/dashboard/personal-info" [ngClass]="{'active': router.url === '/dashboard/personal-info' || router.url === '/dashboard' }" ><img src="./assets/images/menu1.png" class="mr-3 tabmr1" />Personal Info
    <div class="clear10"></div>
        <button *ngIf="isInprogressPI" type="button" class="btn btn-yellow">IN-PROGRESS</button>
        <button *ngIf="isCompletedPI" type="button" class="btn btn-green">COMPLETED </button>
        <button *ngIf="isPendingPI" type="button" class="grey-btn">PENDING</button>
    </a>

    <div class="clear10" [hidden]="Type === 'Office Admin Staff'"></div>
  
        <div [title]="titleNavUD"  [ngClass]="{'wrapper': !isCompletedPI}" [hidden]="Type === 'Office Admin Staff'">
            <span [ngClass]="{'disableDiv': !isCompletedPI }">
    <a   *ngIf="DisableforGATA==false" class="border-bottom" routerLink="/dashboard/upload-documents" [ngClass]="{'active': router.url === '/dashboard/upload-documents' }"><img src="./assets/images/menu2.png" class="mr-3 tabmr1" />Upload Documents
    <div class="clear10"></div>
        
        <button *ngIf="isCompletedUD" type="button" class="btn btn-green">COMPLETED</button>
        <button *ngIf="isInprogressUD" type="button" class="btn btn-yellow">IN-PROGRESS</button>
        <button *ngIf="isPendingUD" type="button" class="grey-btn">PENDING</button>


    </a>
    <a   class="border-bottom" *ngIf="DisableforGATA==true"><img src="./assets/images/menu2.png" class="mr-3 tabmr1" />Upload Documents
    <div class="clear10"></div>
        
        <button *ngIf="isCompletedUD" type="button" class="btn btn-green">COMPLETED</button>
        <button *ngIf="isInprogressUD" type="button" class="btn btn-yellow">IN-PROGRESS</button>
        <button *ngIf="isPendingUD" type="button" class="grey-btn">PENDING</button>


    </a>
            </span>
   </div>
   <div class="clear10" [hidden]="Type === 'Office Admin Staff'"></div>
    <div (click)="onClickOnlineTraining()" [title]="titleNavOT" [ngClass]="{'wrapper': !isCompletedUD}" [hidden]="Type === 'Office Admin Staff'">
        <span [ngClass]="{'disableDiv': !isCompletedUD}">
    <a  class="border-bottom" routerLink="/dashboard/online-training" [ngClass]="{'active': router.url === '/dashboard/online-training' }"><img src="./assets/images/menu1.png" class="mr-3 tabmr1" />Online Training
    <div class="clear10"></div>
    
        <button *ngIf="isCompletedOT" type="button" class="btn btn-green">COMPLETED</button>
        <button *ngIf="isPendingOT" type="button" class="grey-btn">PENDING</button>
        <button *ngIf="isInprogressOT" type="button" class="btn btn-yellow">IN-PROGRESS</button>

    </a>
    
</span>
</div>
<div class="clear10" [hidden]="Type === 'Office Admin Staff'"></div>
<div [title]="titleNavSA"  [ngClass]="{'wrapper': !isCompletedUD}" [hidden]="Type === 'Office Admin Staff'">
    <span [ngClass]="{'disableDiv': !isCompletedUD}">
<a  class="border-bottom" routerLink="/dashboard/contract-sign" [ngClass]="{'active': router.url === '/dashboard/contract-sign' }"><img src="./assets/images/sign-box.png" class="mr-3 tabmr1" />Sign Agreement
<div class="clear10"></div>
   
    <button *ngIf="isCompletedSA" type="button" class="btn btn-green">COMPLETED</button>
    <button *ngIf="isPendingSA" type="button" class="grey-btn">PENDING</button>
    <button *ngIf="isInprogressSA" type="button" class="btn btn-yellow">IN-PROGRESS</button>

</a>
</span>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div class=" privacypolicy">
                <a class="txt-blue3 cp text46 bg-grey"href="https://www.travelance.ca/privacy-policy/" target="_blank"><u>Privacy Policy</u></a>
            </div>
        </div>
        <div class="col-lg-6">
            <div class=" privacypolicy">
                <a class="txt-blue3 cp text46 bg-grey" routerLink="/dashboard/contactus"><u>Contact Us</u></a>
            </div>
        </div>
    </div>
   
  </div>
  
<div class="sidebar border mobdispblock" *ngIf="router.url !='/dashboard/dashboard-mga' && !activeRoute?.includes('/mga-details') && router.url!='/dashboard/sales-home' && router.url!='/dashboard/policy-search' && router.url!='/dashboard/Save-Quotes' && router.url!='/dashboard/Quotes-Purchase' && router.url!='/dashboard/Groups' && router.url!='/dashboard/policy-details' && router.url!='/dashboard/policy-full-refund' && router.url!='/dashboard/change-policy' && router.url!='/dashboard/edit-billing-info'&& router.url!='/dashboard/sales-report'  && router.url!='/dashboard/report-details' && router.url!='/dashboard/agency-admin' && router.url!='/dashboard/forms' && router.url!='/dashboard/resources' && router.url!='/dashboard/OASale-report' && router.url!='/dashboard/OASale-report-details' &&  router.url!='/dashboard/vtc'">
    <div class="clear10"></div>
    <div class="menu outline-0 cp" routerLink="/dashboard"><img class="tablogo" src="./assets/images/tl-215.png"  /></div>
    <div class="clear40"></div>
    <h6 class="semi-bold txt-black2 menu">STEPS</h6>
    <div class="clear20"></div>
    <div class="row border-bottom padb5" routerLink="/dashboard/personal-info" [ngClass]="{'active': router.url === '/dashboard/personal-info' || router.url === '/dashboard' }" > 
        <div class="col-7">
            <div><img src="./assets/images/menu1.png" class="mr-3 tabmr1 mobicon">Personal Info</div>
        </div>
        <div class="col-5">
            <button *ngIf="isInprogressPI" type="button" class="btn btn-yellow">IN-PROGRESS</button>
            <button *ngIf="isCompletedPI" type="button" class="btn btn-green">COMPLETED </button>
            <button *ngIf="isPendingPI" type="button" class="grey-btn">PENDING</button>
        </div>
    
    </div>

    <div class="clear20" [hidden]="Type === 'Office Admin Staff'"></div>
    <div [ngClass]="{'myDiv': !DisableforGATA}">

    
  <div class="row border-bottom padb5" routerLink="/dashboard/upload-documents" [ngClass]="{'active': router.url === '/dashboard/upload-documents' }"[ngClass]="{'disableDiv': !isCompletedPI}"[title]="titleNavUD"  [ngClass]="{'wrapper': !isCompletedPI}" [hidden]="Type === 'Office Admin Staff'">

    <div class="col-7">
    <div><img src="./assets/images/menu2.png" class="mr-3 tabmr1 mobicon" />Upload Documents
    </div>
    </div>
    <div class="clear10"></div>
    <div class="col-5">
    <button *ngIf="isCompletedUD" type="button" class="btn btn-green">COMPLETED</button>
    <button *ngIf="isInprogressUD" type="button" class="btn btn-yellow">IN-PROGRESS</button>
    <button *ngIf="isPendingUD" type="button" class="grey-btn">PENDING</button>
    </div>
  </div>
</div>
    <div class="clear20" [hidden]="Type === 'Office Admin Staff'"></div>

    
    <div class="row border-bottom padb5" (click)="onClickOnlineTraining()" [ngClass]="{'active': router.url === '/dashboard/online-training' }"[ngClass]="{'disableDiv': !isCompletedUD}"[title]="titleNavOT" [ngClass]="{'wrapper': !isCompletedUD}" [hidden]="Type === 'Office Admin Staff'">
        <div class="col-7">
        <div><img src="./assets/images/menu1.png" class="mr-3 tabmr1 mobicon" />Online Training</div>
        </div>
        <div class="clear10"></div>
        <div class="col-5"> 
            <button *ngIf="isCompletedOT" type="button" class="btn btn-green">COMPLETED</button>
            <button *ngIf="isPendingOT" type="button" class="grey-btn">PENDING</button>
            <button *ngIf="isInprogressOT" type="button" class="btn btn-yellow">IN-PROGRESS</button>
    
        </div>
      </div>
    <div class="clear20" [hidden]="Type === 'Office Admin Staff'"></div>
    <div class="row border-bottom padb5" routerLink="/dashboard/contract-sign" [ngClass]="{'active': router.url === '/dashboard/contract-sign' }"[title]="titleNavSA"  [ngClass]="{'wrapper': !isCompletedUD}"[ngClass]="{'disableDiv': !isCompletedUD}" [hidden]="Type === 'Office Admin Staff'">
        <div class="col-7">
        <div><img src="./assets/images/sign-box.png" class="mr-3 tabmr1 mobicon" />Sign Agreement</div>
        </div>
        <div class="clear10"></div>
        <div class="col-5"> 
            <button *ngIf="isCompletedSA" type="button" class="btn btn-green">COMPLETED</button>
            <button *ngIf="isPendingSA" type="button" class="grey-btn">PENDING</button>
            <button *ngIf="isInprogressSA" type="button" class="btn btn-yellow">IN-PROGRESS</button>
        </div>        
    </div>
    
</div>
<div class="sidebar1" *ngIf="router.url !='/dashboard/steps-status' && router.url !='/dashboard/upload-documents' && router.url !='/dashboard/personal-info' && router.url !='/dashboard/contract-sign' && router.url !='/dashboard/online-training' && router.url !='/dashboard' && router.url!='/dashboard/sales-home' && router.url!='/dashboard/policy-search' && router.url!='/dashboard/Save-Quotes' && router.url!='/dashboard/Quotes-Purchase' && router.url!='/dashboard/Groups' && router.url!='/dashboard/policy-details' && router.url!='/dashboard/policy-full-refund' && router.url!='/dashboard/change-policy' && router.url!='/dashboard/edit-billing-info' && router.url!='/dashboard/sales-report'  && router.url!='/dashboard/report-details' && router.url!='/dashboard/agency-admin' && router.url!='/dashboard/forms' && router.url!='/dashboard/resources' &&  router.url!='/dashboard/vtc'">
    <div class="clear10"></div>
    <!-- <div class="menu outline-0 cp" routerLink="/activated"><img src="./assets/images/tl-215.png" /></div> -->
    <div class="clear50"></div>
    <span (click)="menuHideButton == false" class="menuicon p-15" (click)="menuHide()" value="true">&#9776; </span>
    <div *ngIf="menuHideButton == false">
        <img class="p-15 cp"  routerLink="/activated" src="./assets/images/dashboardblue.png"/>
    </div>
    <div *ngIf="menuHideButton == false">
        <img class="p-15 cp "  *ngIf="!(activeRoute?.includes('/dashboard-mga') || activeRoute?.includes('/mga-details'))"  routerLink="/dashboard/dashboard-mga" src="./assets/images/leadblue.svg"/>
        <img class="p-15 cp " [ngClass]="{'activeone': (activeRoute?.includes('/dashboard-mga') || activeRoute?.includes('/mga-details'))}" *ngIf="(activeRoute?.includes('/dashboard-mga') || activeRoute?.includes('/mga-details'))" routerLink="/dashboard/dashboard-mga" src="./assets/images/leadwhite.svg"/>
    </div>
    <div *ngIf="menuHideButton == false">
        <div  *ngIf="ShowReport=='true'">
            <img class="p-15 cp " *ngIf="!(activeRoute?.includes('/OASale-report') || activeRoute?.includes('/OASale-report-details'))" routerLink="/dashboard/OASale-report" src="./assets/images/Blueicon-pie-chart.svg"/>
            <img class="p-15 cp " [ngClass]="{'activeone': (activeRoute?.includes('/OASale-report') || activeRoute?.includes('/OASale-report-details'))}" *ngIf="(activeRoute?.includes('/OASale-report') || activeRoute?.includes('/OASale-report-details'))" routerLink="/dashboard/OASale-report" src="./assets/images/Whiteiconpie-chart.svg"/>
        </div>
    </div>
    <div *ngIf="menuHideButton == true">
        <div routerLink="/activated" class="cp olnone p-15"><img class="mr-1" src="./assets/images/dashboardblue.png"/>
            <span class="ml-4 regular fs-20">Home</span>
        </div>
    </div> 
    <div *ngIf="menuHideButton == true" [ngClass]="{'activeone': (activeRoute?.includes('/dashboard-mga') || activeRoute?.includes('/mga-details'))}">
        <div routerLink="/dashboard/dashboard-mga" class="cp olnone p-15">
            <img *ngIf="!(activeRoute?.includes('/dashboard-mga') || activeRoute?.includes('/mga-details'))" src="./assets/images/leadblue.svg"/>
            <img *ngIf="(activeRoute?.includes('/dashboard-mga') || activeRoute?.includes('/mga-details'))" src="./assets/images/leadwhite.svg"/>
            <span class="ml-4 regular fs-20">Leads</span>
        </div>
    </div>    
    <div *ngIf="menuHideButton == true && ShowReport=='true'" [ngClass]="{'activeone': (activeRoute?.includes('/OASale-report') || activeRoute?.includes('/OASale-report-details'))}">
        <div routerLink="/dashboard/OASale-report" class="cp olnone p-15" *ngIf="ShowReport=='true'">
            <img *ngIf="!(activeRoute?.includes('/OASale-report') || activeRoute?.includes('/OASale-report-details'))" src="./assets/images/Blueicon-pie-chart.svg"/>
            <img *ngIf="(activeRoute?.includes('/OASale-report') || activeRoute?.includes('/OASale-report-details'))" src="./assets/images/Whiteiconpie-chart.svg"/>
            <span class="ml-4 regular fs-20">Reports</span>
        </div>
    </div>  
 </div>